import React from 'react';
import { graphql, Link } from 'gatsby';
import basicMapDataToComponents from './basicMapDataToComponents';
import LightArticleRenderer from '../components/shared/lightArticleRenderer';
import * as style from './fellowship.module.scss';
import FellowshipHeader from '../components/article/fellowshipHeader';
import LogoSvg from '../components/global/logoSvg';
import Partnership from '../components/latestStories/partnership';
import StoryCardList from '../components/shared/storyCardList';
import ArticleList from '../components/article/articleList';
import translations from '../utils/translations';

const fellowshipConfig = {
  style,
  renderHeader: (itemsJson) => {
    const { title, meta_description, authors, created_date, hide_date, featured_image, featured_video, youtube_video } = itemsJson;
    return (
      <FellowshipHeader authors={authors}
        createdDate={created_date}
        title={title}
        subtitle={meta_description}
        credit={featured_image ? featured_image?.image?.credit_plain : ''}
        hideDate={hide_date}
        src={featured_image ? featured_image?.image?.sizes?.hero_lg : ''}
        featuredVideo={featured_video}
        youtubeVideo={youtube_video}
      />
    );
  },
  renderLogoLink: (s) => (
    <div className={s.logo}>
      <Link to="/">
        <LogoSvg />
      </Link>
    </div>
  ),
  renderLeftColumn: ({ partnerships, style: s }) => (
    <>
      {partnerships && partnerships.length > 0 && partnerships.map(function(item, i) {
        return (
          <div key={i}>
            <Partnership
              label={item.title}
              alternate
              fellowshipPage
            >
              <img src={item.path} className={s.imageMaxWidth100} alt={item.title || ''} />
              <p>{item.text}</p>
            </Partnership>
          </div>
        );
      })}
    </>
  ),
  renderRelatedReading: ({ relatedReading, style: s }) => (
    relatedReading?.items
      ? <div className={s.relatedReading}>
          <ArticleList theme="off-white" articles={relatedReading.items} label={translations.t("Related Reading")} />
        </div>
      : null
  ),
  renderBottomStories: ({ data, lang, style: s }) => {
    const latestFellowshipStories = data.megaMenu?.edges?.find(e => e.node?.lang === lang)?.node?.latest_fellowship_stories ?? [];
    return (
      <StoryCardList
        items={latestFellowshipStories}
        sectionId="FellowshipStories"
        heading="FELLOWSHIP STORIES"
        getImageUrl={(item) => item?.image?.sizes?.hero_sm ?? ''}
        styles={s}
      />
    );
  },
  renderBottomCallouts: (bottomCallouts) => (
    bottomCallouts.length > 0
      ? basicMapDataToComponents(bottomCallouts, { reveal: true })
      : null
  ),
  paragraphOptions: {
    simpleButtonOpenBlank: true,
  },
  socialShareColor: 'orange',
};

const Article = (props) => (
  <LightArticleRenderer
    {...props}
    config={fellowshipConfig}
  />
);

export default Article;

// eslint-disable-next-line
export const articlePageQuery = graphql`
  query Fellowship(
    $path: String!,
    $climateTrendId: String!,
    $popularStoriesId: String!,
    $isEs: Boolean!,
    $idRegex: String!,
    $blog: String!,
    $translations: String!) {
   itemsJson(path: { eq: $path }) {
      title
      hide_date
			created_date
      short_description
      meta_description
      article_type
      related_challenge {
        title
      }
      archive {
        title
        path
      }
      authors {
        id
        name
        description
        description_plain
        social_media_link {
          uri
          title
        }
        linkedin_link {
          uri
          title
        }
        bio_url {
          uri
          title
        }
        bio_image {
          url
          alt
        }
      }
      youtube_video {
        credit
        url
      }
      make_this_article_faq
      featured_image {
        image {
          sizes {
            hero_lg
            hero_md
            hero_sm
            original
          }
          credit_plain
        }
      }
      video {
        url
      }
      related_impacted_regions {
        content_type
        path
        title
        region_id
      }
      featured_video {
        id
        url
        caption
        image {
          sizes {
            original
            standard_md
            standard_sm
          }
        }
      }
      categories {
        name
        es_name
        link
      }
        prevent_indexing
      ...queryParagraphFields
    }
    climateTrends: itemsJson(jsonId: { eq: $climateTrendId }) {
      path
    }
    popular_stories: itemsJson(jsonId: { eq: $popularStoriesId }) {
      articles {
        id
        title
        path
        archive {
          title
          path
        }
        authors {
          name
        }
      }
    }

  ...headerFields @skip(if:$isEs)
	...footerFields @skip(if:$isEs)
  ...headerFieldsEs @include(if:$isEs)
  ...footerFieldsEs @include(if:$isEs)
	...SharedChallengesFields
	...SharedPagesFields
	...SharedBlogFields
	...SharedTranslationsFields
  ...SharedNewsletterEnFields
  ...SharedNewsletterEsFields
	...MegaMenuFields
}
`;
